/* eslint-disable @typescript-eslint/no-non-null-assertion */
import axios, { AxiosError, AxiosRequestConfig } from 'axios'

import { API_CONFIG, getEnv } from '../config/api'
import { ApiResponse, ErrorData } from '../interfaces'
import { ILogin } from '../redux/login'

const env = getEnv()

const {
  sendTo: { url: sendToURL, token },
} = API_CONFIG[env]

const sendToFromMiddleware = async (
  userId: string,
  data: ILogin,
  middleware?: AxiosRequestConfig
): Promise<ApiResponse<string | ErrorData>> => {
  try {
    const { status } = await axios({
      ...middleware,
      data: { userId, data },
    })

    return {
      data: 'redirect successful',
      status,
      success: true,
    }
  } catch (err) {
    const { response } = err as AxiosError<ErrorData>
    const { data, status } = response!

    return {
      data,
      status,
      success: false,
    }
  }
}

const sendToFromBSNG = async (userId: string, data: ILogin): Promise<ApiResponse<string | ErrorData>> => {
  try {
    const { status } = await axios.post(
      sendToURL,
      { userId, data },
      {
        headers: {
          'x-api-key': token,
        },
      }
    )

    return {
      data: 'redirect successful',
      status,
      success: true,
    }
  } catch (err) {
    const { response } = err as AxiosError<ErrorData>
    const { data, status } = response!

    return {
      data,
      status,
      success: false,
    }
  }
}

const sendTo = async (
  userId: string,
  data: ILogin,
  middleware?: AxiosRequestConfig
): Promise<ApiResponse<string | ErrorData>> => {
  let response

  if (middleware) {
    response = await sendToFromMiddleware(userId, data, middleware)
  } else {
    response = await sendToFromBSNG(userId, data)
  }

  return response
}

export default sendTo
